function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import * as Sentry from "@sentry/nextjs";
import mapValues from "lodash/mapValues";
import keyBy from "lodash/keyBy";
import omit from "lodash/omit";
import DataLayerEventTypes from "constants/data-layer-event-types";
import { HUBSPOT_FORM_SUBMIT_CLICKED, HUBSPOT_FORM_READY } from "constants/bigbrain-event-types";
import { HUBSPOT_API_COMPANY_SIZE, PII_PARAMS } from "client/services/hubspot-service/hubspot-constants";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import { trackEvent } from "services/bigbrain-service";
import * as HubspotService from "client/services/hubspot-service/hubspot-service";
/**
 * Track form submission analytics for BaseForm
 * Fires both GTM and BigBrain tracking events
 */ export const trackFormSubmission = (convertedFormData, formId, cloudfrontViewerCountry, localeId)=>{
    const companySizeValue = HubspotService.getValueFromHSFields(convertedFormData, HUBSPOT_API_COMPANY_SIZE);
    fireGtmEvent(DataLayerEventTypes.HUBSPOT_FORM_SUBMITTED, {
        formId
    });
    try {
        const formDataMap = mapValues(keyBy(convertedFormData, "name"), "value");
        const sanitizedData = omit(_object_spread_props(_object_spread({}, formDataMap), {
            country: cloudfrontViewerCountry,
            language: localeId
        }), [
            ...PII_PARAMS,
            "hs_context"
        ]);
        trackEvent(HUBSPOT_FORM_SUBMIT_CLICKED, {
            kind: formId,
            info1: companySizeValue,
            data: sanitizedData
        });
    } catch (error) {
        Sentry.captureException(error);
    }
};
/**
 * Track form submission analytics for fallback HubSpot form
 * Similar to trackFormSubmission but accepts different data format
 */ export const trackHubspotFormSubmission = (formData, formId, cloudfrontViewerCountry, localeId)=>{
    var _formData_find;
    const companySize = formData === null || formData === void 0 ? void 0 : (_formData_find = formData.find((field)=>field.name === HUBSPOT_API_COMPANY_SIZE)) === null || _formData_find === void 0 ? void 0 : _formData_find.value;
    fireGtmEvent(DataLayerEventTypes.HUBSPOT_FORM_SUBMITTED, {
        formId
    });
    try {
        const formDataMap = mapValues(keyBy(formData, "name"), "value");
        const sanitizedData = omit(_object_spread_props(_object_spread({}, formDataMap), {
            country: cloudfrontViewerCountry,
            language: localeId
        }), [
            ...PII_PARAMS,
            "hs_context"
        ]);
        trackEvent(HUBSPOT_FORM_SUBMIT_CLICKED, {
            kind: formId,
            info1: companySize,
            data: sanitizedData
        });
    } catch (error) {
        Sentry.captureException(error);
    }
};
/**
 * Track form ready event (for input blur or form ready)
 * Simple tracking for when forms become interactive
 */ export const trackFormReady = (formId)=>{
    trackEvent(HUBSPOT_FORM_READY, {
        kind: formId
    });
};
